import React, { useState } from "react";
import { fontsName } from "../../assets/fonts/fontsName";
// import img5 from "../../assets/images/blog/best1.jpg";
import {/* Typography, */useTheme, useMediaQuery } from "@material-ui/core";
import { request, gql } from "graphql-request";
import ChartInfoModal from "./ChartInfoModal";
import { REQUEST_URL } from "../RequestUrl";

const CHART_INFO = gql`
  {
    getAllWebsiteOrganizationalChart {
      _id
      pictureLink
      description
      post
      postType
      fullName
      academicHistory
      jobHistory
    }
  }
`;

const ChartScreen = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [teachersInfo, setTeachersInfo] = React.useState([]);
  const [personInfo, setPersonInfo] = React.useState({});
  const theme = useTheme();
  const responsive = useMediaQuery(theme.breakpoints.only("xs"));
  // const [visible, setVisible] = useState("none");

  React.useEffect(() => {
    request(REQUEST_URL, CHART_INFO).then((data) => {
      console.log("getAllWebsiteOrganizationalChart:", data.getAllWebsiteOrganizationalChart)
      setTeachersInfo(data.getAllWebsiteOrganizationalChart);
    });
  }, []);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div className="subscribe-area ptb-100">
        <div className="container">
          <div
            // dir="rtl"
            // style={{ textAlign: "right" }}
            // className="manage-part"
            className="chart-item"
          >
            <p style={{ fontFamily: fontsName.VazirBold, fontSize: "30px" }}>
              مدیریت
            </p>
            <div className="chart-info">
              {teachersInfo && teachersInfo.length > 0
                ? teachersInfo.map((item, index) => (
                  <>
                    {item.post === "0" && (
                      //   <img
                      //     src={item.pictureLink}
                      //     key={index}
                      //     style={{
                      //       width: "200px",
                      //       height: "200px",
                      //       cursor: "pointer",
                      //     }}
                      //     onClick={() => {
                      //       setPersonInfo({});
                      //       handleOpen();
                      //       setPersonInfo(item);
                      //     }}
                      //   />
                      <div
                        dir="rtl"
                        style={{
                          textAlign: "right",
                          marginLeft: "10px",
                          marginTop: "10px",
                        }}
                      >
                        <img
                          key={index}
                          src={item.pictureLink}
                          style={{
                            width: "200px",
                            height: "200px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setPersonInfo({});
                            handleOpen();
                            setPersonInfo(item);
                          }}
                        />
                        <p
                          style={{
                            fontFamily: fontsName.VazirBold,
                            textAlign: "center",
                            marginTop: "5px",
                          }}
                        >
                          {item.fullName}
                        </p>
                      </div>
                    )}
                  </>
                ))
                : ""}
            </div>

            {/* <img
              src={img5}
              style={{ width: "200px", height: "200px", cursor: "pointer" }}
              onClick={handleOpen}
            /> */}
            {/* <div
            style={{
              width: "25%",
              padding: "8px 12px",
              backgroundColor: "lavender",
              display: visible,
              transition: "1s",
            }}
            onMouseEnter={handleOpen}
            onMouseLeave={handleClose}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                style={{ fontFamily: fontsName.Vazir, marginBottom: "0px" }}
              >
                نام و نام خانوادگی :
              </label>
              <p style={{ fontFamily: fontsName.Vazir }}>
                لورم ایپسوم فارسی
              </p>
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                style={{ fontFamily: fontsName.Vazir, marginBottom: "0px" }}
              >
                تحصیلات :
              </label>
              <p style={{ fontFamily: fontsName.Vazir }}>
                لورم ایپسوم فارسی،لورم ایپسوم فارسی،لورم ایپسوم فارسی
              </p>
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                style={{ fontFamily: fontsName.Vazir, marginBottom: "0px" }}
              >
                سابقه شغلی :
              </label>
              <p style={{ fontFamily: fontsName.Vazir }}>
                لورم ایپسوم فارسی،لورم ایپسوم فارسی،لورم ایپسوم فارسی،لورم
                ایپسوم فارسی،لورم ایپسوم فارسی،لورم ایپسوم
              </p>
            </div>
          </div> */}
          </div>

          <div className="chart-item">
            <p style={{ fontFamily: fontsName.VazirBold, fontSize: "30px" }}>
              معاونین
            </p>
            <div className="chart-info">
              {teachersInfo && teachersInfo.length > 0
                ? teachersInfo.map((item, index) => (
                  <>
                    {console.log("index2:", index)}
                    {item.post === "1" && (
                      <div
                        dir="rtl"
                        style={{
                          textAlign: "right",
                          marginLeft: "10px",
                          marginTop: "10px",
                        }}
                      >
                        <img
                          key={index}
                          src={item.pictureLink}
                          style={{
                            width: "200px",
                            height: "200px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setPersonInfo({});
                            handleOpen();
                            setPersonInfo(item);
                          }}
                        />
                        <p
                          style={{
                            fontFamily: fontsName.VazirBold,
                            textAlign: "center",
                            marginTop: "5px",
                          }}
                        >
                          {item.fullName}
                        </p>
                      </div>
                    )}
                  </>
                ))
                : ""}
              {/* <div dir="rtl" style={{ textAlign: "right", marginLeft: "10px" }}>
                <img
                  src={img5}
                  style={{ width: "200px", height: "200px", cursor: "pointer" }}
                  onClick={handleOpen}
                />
              </div>

              <div dir="rtl" style={{ textAlign: "right", marginLeft: "10px" }}>
                <img
                  src={img5}
                  style={{ width: "200px", height: "200px", cursor: "pointer" }}
                  onClick={handleOpen}
                />
              </div>

              <div dir="rtl" style={{ textAlign: "right", marginLeft: "10px" }}>
                <img
                  src={img5}
                  style={{ width: "200px", height: "200px", cursor: "pointer" }}
                  onClick={handleOpen}
                />
              </div> */}
            </div>
          </div>

          <div className="chart-item">
            <p style={{ fontFamily: fontsName.VazirBold, fontSize: "30px" }}>
              مشاورین
            </p>
            <div className="chart-info">
              {teachersInfo && teachersInfo.length > 0
                ? teachersInfo.map((item, index) => (
                  <>
                    {item.post === "3" && (
                      <div
                        dir="rtl"
                        style={{
                          textAlign: "right",
                          marginLeft: "10px",
                          marginTop: "10px",
                        }}
                      >
                        <img
                          key={index}
                          src={item.pictureLink}
                          style={{
                            width: "200px",
                            height: "200px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setPersonInfo({});
                            handleOpen();
                            setPersonInfo(item);
                          }}
                        />
                        <p
                          style={{
                            fontFamily: fontsName.VazirBold,
                            textAlign: "center",
                            marginTop: "5px",
                          }}
                        >
                          {item.fullName}
                        </p>
                      </div>
                    )}
                  </>
                ))
                : ""}

              {/* <div dir="rtl" style={{ textAlign: "right", marginLeft: "10px" }}>
                <img
                  src={img5}
                  style={{ width: "200px", height: "200px", cursor: "pointer" }}
                  onClick={handleOpen}
                />
              </div>

              <div dir="rtl" style={{ textAlign: "right", marginLeft: "10px" }}>
                <img
                  src={img5}
                  style={{ width: "200px", height: "200px", cursor: "pointer" }}
                  onClick={handleOpen}
                />
              </div>

              <div dir="rtl" style={{ textAlign: "right", marginLeft: "10px" }}>
                <img
                  src={img5}
                  style={{ width: "200px", height: "200px", cursor: "pointer" }}
                  onClick={handleOpen}
                />
              </div> */}
            </div>
          </div>

          <div className="chart-item">
            <p style={{ fontFamily: fontsName.VazirBold, fontSize: "30px" }}>
              معلمین
            </p>
            <div className="chart-info">
              {teachersInfo && teachersInfo.length > 0
                ? teachersInfo.map((item, index) => (
                  <>
                    {console.log("index:", item)}
                    {item.post === "2" && (
                      <div
                        dir="rtl"
                        style={{
                          textAlign: "right",
                          marginLeft: "10px",
                          marginTop: "10px",
                        }}
                      >
                        <img
                          key={index}
                          src={item.pictureLink}
                          style={{
                            width: "200px",
                            height: "200px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setPersonInfo({});
                            handleOpen();
                            setPersonInfo(item);
                          }}
                        />
                        <p
                          style={{
                            fontFamily: fontsName.VazirBold,
                            textAlign: "center",
                            marginTop: "5px",
                          }}
                        >
                          {item.fullName}
                        </p>
                      </div>
                    )}
                  </>
                ))
                : ""}

              {/* <div dir="rtl" style={{ textAlign: "right", marginLeft: "10px" }}>
                <img
                  src={img5}
                  style={{ width: "200px", height: "200px", cursor: "pointer" }}
                  onClick={handleOpen}
                />
              </div>

              <div dir="rtl" style={{ textAlign: "right", marginLeft: "10px" }}>
                <img
                  src={img5}
                  style={{ width: "200px", height: "200px", cursor: "pointer" }}
                  onClick={handleOpen}
                />
              </div>

              <div dir="rtl" style={{ textAlign: "right", marginLeft: "10px" }}>
                <img
                  src={img5}
                  style={{ width: "200px", height: "200px", cursor: "pointer" }}
                  onClick={handleOpen}
                />
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <ChartInfoModal
        open={isOpen}
        onClose={handleClose}
        personInfo={personInfo}
      />
    </>
  );
};

export default ChartScreen;
